import styled, { css } from "styled-components";

import ValidationWrapper from "./ValidationWrapper";

const StyledValidationWrapper = styled(ValidationWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
  height: ${({ height }) => height ?? "100%"};

  ${({ centered }) =>
    centered &&
    css`
      align-items: center;
    `};
`;

export default StyledValidationWrapper;
